export default __webpack_public_path__ + "static/media/Logo.3e0eac87.svg";